// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { BookingContactsComponent } from './booking-contacts.component';
import { CardModule } from 'libraries/ui_card/card.module';
import { BookingContactsContactModule } from 'libraries/component/booking-contacts-contact/booking-contacts-contact.module';

@NgModule({
    declarations: [
        BookingContactsComponent,
    ],
    imports: [
        CommonModule,
        BookingContactsContactModule,
        CardModule,
    ],
    exports: [
        BookingContactsComponent,
    ],
    providers: [],
})
export class BookingContactsModule {}